import { pageLoaded } from "venuescanner-js/tools/elemental";
import { signOut } from "./post";
import {
  hostRedirect,
  reloadNavbar,
} from "venuescanner-js/vanilla/widgets/navbar";
import { authService } from "venuescanner-js/services/auth";
import { popup } from "venuescanner-js/vanilla/components/popup";
import CustomEvents, { Events } from "venuescanner-js/services/windowEvents";
import Login from "venuescanner-js/react/components/SignIn";

const buttons = {
  signIn: null,
  register: null,
};
let attached = false;

export const auth = {
  attach: () => {
    if (attached) return;
    buttons.signIn = document.body.querySelectorAll("button.sign-in");
    buttons.signIn.forEach((button) => {
      button.addEventListener("click", (e) => {
        Login({
          showSignIn: true,
          afterLogin: (...args) => {
            auth.processReceivedLogin(...args);
          },
        });
      });
    });
    buttons.register = document.body.querySelectorAll("button.sign-up");
    buttons.register.forEach((button) => {
      button.addEventListener("click", (e) => {
        Login({
          showSignIn: false,
          afterLogin: (...args) => {
            auth.processReceivedLogin(...args);
          },
        });
      });
    });
    if (window) {
      window.signOut = signOut;
    }

    attached = true;
  },
  open: async (showSignIn = true) => {
    Login({
      showSignIn,
      afterLogin: (...args) => {
        auth.processReceivedLogin(...args);
      },
    });
  },
  signOut: () => {
    signOut();
  },
  afterLogin: null,
  processReceivedLogin: async function ({ login, register }) {
    const response = register || login;
    // console.log({response})
    // const { user } = response.data
    window.justSignedUp = true;
    // console.log({ user: { ...response.user } })
    authService.setUserInfo(response);
    if (register) {
      window.dataLayer.push({
        event: "signed_up",
        user: {
          role: authService.user.role,
          name: authService.user.name,
          id: authService.user._id,
          userType: authService.user.user_type,
          email: authService.user.email,
        },
      });
    }
    window.justSignedIn = true;
    // window.data.viewerToken = response.data.access_token
    // window.user = user
    if (authService.user.role.match(/admin/i)) {
      window.admin_user = authService.user;
    } else if (!this.afterLogin) {
      if (authService.user.user_type === "host") {
        hostRedirect(authService.user);
      }
    }
    CustomEvents[Events.loggedIn](authService.user); // triggers logged in events

    // trigger windowEvents.authWidgetClosed
    // window.dispatchEvent(new Event(windowEvents.authWidgetClosed))
    // popup.show('Updating...', { loading: true })
    try {
      await reloadNavbar();
      authService.updateNavbar();
      if (typeof this.afterLogin === "function") {
        this.afterLogin();
        this.afterLogin = null;
      }
      popup.close();
    } catch (e) {
      console.error(e);
    }
  },
  mustBeLoggedIn: function (afterLogin = null) {
    if (authService.isLoggedIn()) {
      // console.log("Is logged in")
      if (afterLogin) afterLogin();
      return true;
    } else {
      // console.log("Not logged in")
      this.afterLogin = afterLogin;
      this.open();
      return false;
    }
  },
};

pageLoaded(() => {
  auth.attach();
});
